import { render } from "./camera.vue?vue&type=template&id=24636126"
import script from "./camera.vue?vue&type=script&lang=js"
export * from "./camera.vue?vue&type=script&lang=js"
script.render = render

export default script